import { render, staticRenderFns } from "./RTETitleIcon.vue?vue&type=template&id=02dd4aa7&scoped=true"
import script from "./RTETitleIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./RTETitleIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd4aa7",
  null
  
)

export default component.exports